// src/components/entrega/Entrega.js
import React from "react";
import "./Styles.css";
import { FaTruck, FaWhatsapp } from "react-icons/fa";

const Entrega = () => {
  return (
    <section className="delivery-section">
      <h2 className="section-title">Entrega</h2>

      <div className="delivery-cards">
        <div className="delivery-card">
          <FaTruck size={40} color="#00c6ff" />
          <p>
            Retiramos seu computador ou notebook em Pilar do Sul e entregamos pronto em até 48 horas. Serviço seguro e rápido.
          </p>
        </div>

        <div className="delivery-card">
          <FaTruck size={40} color="#00c6ff" />
          <p>
            Serviço ágil e confiável, garantindo que seu equipamento esteja em perfeitas condições na entrega.
          </p>
        </div>

        <div className="delivery-card">
          <FaTruck size={40} color="#00c6ff" />
          <p>
            Atendimento personalizado, monitorando cada etapa até a entrega final ao cliente.
          </p>
        </div>
      </div>

      <h2 className="section-title">Localização</h2>

      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3650.861682221886!2d-47.72762258450468!3d-23.802481684591796!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94c598d59ef92f2b%3A0x50607eeccf11f044!2sR.%20Francisco%20Ferreira%20dos%20Santos%2C%20400%20-%20PINHEIROS%2C%20Pilar%20do%20Sul%20-%20SP%2C%2018185-000%2C%20Brasil!5e0!3m2!1spt-BR!2sbr!4v1700000000000"
        width="70%"
        height="400"
        style={{
          border: 0,
          borderRadius: "10px",
          display: "block",
          margin: "0 auto",
        }}
        allowFullScreen
        loading="lazy"
        title="Mapa de Localização"
      ></iframe>

      {/* Botão WhatsApp padronizado */}
      <a
        href="https://wa.me/5515996879862?text=Ol%C3%A1!%20Vi%20sua%20landing%20page%20e%20quero%20agendar%20um%20servi%C3%A7o%20de%20manuten%C3%A7%C3%A3o."
        target="_blank"
        rel="noopener noreferrer"
        className="btn-whatsapp"
      >
        <FaWhatsapp size={20} /> Fale conosco
      </a>
    </section>
  );
};

export default Entrega;
